import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getClientServicesList = async (token, options = {}) => {
    log("welcome in getClientServicesList")

    if (!token || token === "") {
        alert("No token in getClientServicesList")
        return {error: true, message: "No token provided", client_services: [], total_count: 0}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/get_client_services_list_api'
        log("url=" + url)

        // Build query params
        const params = {}

        // Search term
        if (options.search_term) {
            params.search_term = options.search_term
        }

        // Subclients
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }
        if (options.subclient_id) {
            params.subclient_id = options.subclient_id
        }

        // Service type filter (single)
        if (options.service_type_id) {
            params.service_type_id = options.service_type_id
        }

        // Service type IDs filter (multiple)
        if (options.service_type_ids && options.service_type_ids.length > 0) {
            params['service_type_ids[]'] = options.service_type_ids
        }

        // Status IDs (array)
        if (options.status_ids && options.status_ids.length > 0) {
            params['status_ids[]'] = options.status_ids
        }

        // Sorting
        if (options.sort_by) {
            params.sort_by = options.sort_by
        }
        if (options.sort_order) {
            params.sort_order = options.sort_order
        }

        // Pagination
        if (options.page) {
            params.page = options.page
        }
        if (options.per_page) {
            params.per_page = options.per_page
        }

        // SIM ID filter (for viewing services of a specific SIM)
        if (options.sim_id) {
            params.sim_id = options.sim_id
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getClientServicesList")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getClientServicesList")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getClientServicesList", client_services: [], total_count: 0}
    }
}

export const getClientServicesStats = async (token, clientId, includeSubclients = false) => {
    log("welcome in getClientServicesStats")

    if (!token || token === "") {
        alert("No token in getClientServicesStats")
        return {error: true, message: "No token provided", stats: {}}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_client_services_stats_api'
        const params = {
            client_id: clientId,
            include_subclients: includeSubclients
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getClientServicesStats")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getClientServicesStats")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getClientServicesStats", stats: {}}
    }
}

const useGetClientServicesAPI = () => {
    return {error, getClientServicesList, getClientServicesStats}
}

export default useGetClientServicesAPI
